import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import Webcam from 'components/Webcam';
import {LivenessInstructions} from '../LivenessInstructions';
import {StepStatus} from 'components/LivenessDetection/types';
import {ChallengeProgressBar} from '../ChallengeProgressBar';

export const Wrapper = styled.div<{$status?: StepStatus}>`
  display: flex;
  justify-content: center;

  & > .webcam {
    background: #e2e2e2;
  }

  .webcam__scan-area {
    ${({$status}) => {
      switch ($status) {
        case 'success':
          return css`
            border-color: #32d7be;
          `;
        case 'error':
          return css`
            border-color: #f44336;
          `;
      }
    }}
  }
`;

export const StyledWebcam = styled(Webcam)<{roundedScanArea?: boolean}>`
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 6;
  left: 0;
  top: 0;
  border-radius: 0;

  & .webcam__scan-area {
    height: 100%;
    max-height: 209px;

    @media (orientation: landscape) {
      max-height: 100%;
      height: 80%;
    }

    ${props =>
      props.roundedScanArea &&
      css`
        top: -60px;
        max-height: 55%;
        max-width: 80%;
        height: 100%;
        width: 100%;

        @media (max-width: ${device.mobileM}) {
          max-height: 369px;
          max-width: 261px;
          height: 100%;
          width: 100%;
        }

        @media (max-width: ${device.mobileS}) {
          max-height: 318px;
          max-width: 220px;
          height: 100%;
          width: 100%;
        }

        @media (orientation: landscape) {
          max-height: 90%;
          max-width: 261px;
          height: 100%;
          width: 100%;
        }
      `}
  }
`;

export const Title = styled.div`
  position: fixed;
  top: 32px;
  left: 50%;
  white-space: nowrap;
  transform: translate(-50%, 0);
  z-index: 7;
  color: white;
  font-size: 18px;
  font-weight: 700;

  @media (orientation: landscape) {
    top: 5px;
  }
`;

export const BackIconButton = styled.div`
  position: fixed;
  top: 36px;
  left: 28px;
  z-index: 7;

  @media (orientation: landscape) {
    top: 70px;
    left: 50px;
  }
`;

export const MobileLivenessInstructions = styled(LivenessInstructions)`
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  z-index: 7;

  color: white;
`;

export const ChallengeProgressBarStyled = styled(ChallengeProgressBar)`
  position: fixed;
  z-index: 6;
  bottom: 0;
`;
